import qcellsLogo from "@/assets/logos/qcells.png";
import silithiumLogo from "@/assets/logos/silithium.png";
import reutlingenLogo from "@/assets/logos/reutlingen.png";
import sovdLogo from "@/assets/logos/sovd.png";
import nxbratingLogo from "@/assets/logos/nxbrating.png";
import mitclaimLogo from "@/assets/logos/mitclaim.png";
import dasstudioLogo from "@/assets/logos/dasstudio.png";
import hmLogo from "@/assets/logos/hm.svg";
import atecLogo from "@/assets/logos/atec.svg";
import camponovoLogo from "@/assets/logos/camponovo.svg";
import koblenzLogo from "@/assets/logos/koblenz.png";
import hiLogo from "@/assets/logos/hi.svg";
import ihrLogo from "@/assets/logos/ihr.svg";
import duisburgLogo from "@/assets/logos/duisburg.png";
import mediaboxxLogo from "@/assets/logos/mediaboxx.svg";
import tumorforschungLogo from "@/assets/logos/tumorforschung.svg";
import offenbachLogo from "@/assets/logos/offenbach.png";
import bgehLogo from "@/assets/logos/bgeh.png";
import leifeldNihonspindleLogo from "@/assets/logos/leifeld-nihonspindle.png";
import { useLanguage } from "@/hooks/useLanguage";

type LogoFilter = "blue" | "white" | "none";

type CustomerLogo = {
  name: string;
  src: string;
  filter: LogoFilter;
};

const blueFilter = "brightness(0) sepia(1) saturate(5) hue-rotate(185deg)";
const whiteLogoFilter = "invert(1) brightness(0) sepia(1) saturate(5) hue-rotate(185deg)";

const CustomerLogosSection = () => {
  const { t } = useLanguage();

  const customerLogos: CustomerLogo[] = [
    { name: "QCells", src: qcellsLogo, filter: "blue" },
    { name: "Silithium", src: silithiumLogo, filter: "blue" },
    { name: "Reutlingen", src: reutlingenLogo, filter: "blue" },
    { name: "SoVD", src: sovdLogo, filter: "blue" },
    { name: "NXB Rating", src: nxbratingLogo, filter: "blue" },
    { name: "Mit Claim", src: mitclaimLogo, filter: "blue" },
    { name: "Das Studio", src: dasstudioLogo, filter: "blue" },
    { name: "HM", src: hmLogo, filter: "blue" },
    { name: "ATEC", src: atecLogo, filter: "blue" },
    { name: "Camponovo", src: camponovoLogo, filter: "blue" },
    { name: "IHK Koblenz", src: koblenzLogo, filter: "white" },
    { name: "HI", src: hiLogo, filter: "white" },
    { name: "IHR", src: ihrLogo, filter: "blue" },
    { name: "IHK Duisburg", src: duisburgLogo, filter: "white" },
    { name: "Mediaboxx", src: mediaboxxLogo, filter: "blue" },
    { name: "Stiftung Tumorforschung", src: tumorforschungLogo, filter: "blue" },
    { name: "IHK Offenbach", src: offenbachLogo, filter: "white" },
    { name: "BGEH", src: bgehLogo, filter: "white" },
    { name: "Leifeld & Nihon Spindle", src: leifeldNihonspindleLogo, filter: "white" },
  ];

  const duplicatedLogos = [...customerLogos, ...customerLogos];

  const getLogoStyle = (filter: LogoFilter) => {
    if (filter === "none") return undefined;

    return {
      filter: filter === "white" ? whiteLogoFilter : blueFilter,
    };
  };

  return (
    <section className="py-12 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="bg-secondary/40 border border-border/50 rounded-2xl py-8 px-4 overflow-hidden">
          <p className="text-center text-sm text-muted-foreground font-medium uppercase tracking-wider mb-6">
            {t("customerLogos.title")}
          </p>

          <div className="relative overflow-hidden">
            <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-secondary/40 to-transparent z-10 pointer-events-none rounded-l-2xl" />
            <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-secondary/40 to-transparent z-10 pointer-events-none rounded-r-2xl" />

            <div className="flex w-max min-w-max items-center animate-marquee whitespace-nowrap will-change-transform">
              {duplicatedLogos.map((logo, index) => (
                <div
                  key={`${logo.name}-${index}`}
                  className="flex h-12 flex-shrink-0 items-center justify-center px-8"
                >
                  <img
                    src={logo.src}
                    alt={logo.name}
                    className="h-8 md:h-10 w-auto object-contain opacity-80 transition-opacity duration-300 hover:opacity-100"
                    style={getLogoStyle(logo.filter)}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerLogosSection;
